(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/prescript.js');
'use strict';

var svs = svs || {};

svs.components = svs.components || {};
svs.components.emp_video_player = svs.components.emp_video_player || {};
svs.components.emp_video_player.helpers = svs.components.emp_video_player.helpers || {};


 })(window);